module.exports = {
  // JCRing成员页
  JCRing_member: {
    //首页
    index1: "Здоровье членов",
    index2: "Группа здоровья",
    index3: "Член",
    index4: "Добавить группу",
    index5: "Присоединённые группы",
    index6: "Настройки предупреждения",
    index7:
      "Позвольте людям, которые заботятся о вашем здоровье, заботиться о вас еще больше",
    index8: "Пока не присоединились к группе",
    index9: "Центр сообщений",
    index10: "Пригласите присоединиться через /телефон/ email/ QR-код/ Wechat",

    //创建群组
    addgroup1: "Название группы",
    addgroup2: "Тип группы",
    addgroup3: "Пожалуйста, введите название группы",
    addgroup4: "Семейная группа",
    addgroup5: "Группа компании",
    addgroup6: "Другие группы",
    addgroup7: "Медицинская группа",
    addgroup8: "Школьная группа",
    addgroup9: "Подтвердить",
    addgroup10: "Создать сейчас",
    addgroup11: "Создать сейчас",
    addgroup12: "Название группы уже существует",

    //成员列表
    memberlist1: "Список членов",
    memberlist2: "Есть",
    memberlist3: "Аномалия",
    memberlist4: "Нормальный",
    memberlist5: "Добавить члена",
    memberlist6: "Распустить",
    memberlist7: "Пока нет членов",
    memberlist8: "Загрузка...",
    memberlist9: "Вы действительно хотите распустить эту группу?",
    memberlist10: "Успешно распущено",
    memberlist11: "Успешно сохранено",
    memberlist12: "Изменить информацию о группе",
    memberlist13: "Распустить группу",
    memberlist14: "Обзор здоровья",
    memberlist15: "Нормальный",
    memberlist16: "Аномалия",
    memberlist17: "Нажмите для просмотра",
    memberlist18: "Данных за вчера нет",
    memberlist19: "Вчера",
    memberlist20: "Отправлено",
    memberlist21: "приглашение в группу ожидает подтверждения",

    //修改成员
    updatemember1: "Аватар",
    updatemember2: "Изменить",
    updatemember3: "Исходное Имя",
    updatemember4: "Изменить Имя",

    //健康数据
    healthdata1: "Данные о здоровье",
    healthdata2: "Данные о здоровье",
    healthdata3: "Воскресенье",
    healthdata4: "Понедельник",
    healthdata5: "Вторник",
    healthdata6: "Среда",
    healthdata7: "Четверг",
    healthdata8: "Пятница",
    healthdata9: "Суббота",
    healthdata10: "Частота сердечных сокращений",
    healthdata11: "HRV",
    healthdata12: "Систолическое давление",
    healthdata13: "Диастолическое давление",
    healthdata14: "Изменение температуры",
    healthdata15: "Насыщение крови кислородом",
    healthdata16: "Сон",
    healthdata17: "Стресс",
    healthdata18: "Холестерин",
    healthdata19: "Триглицериды",
    healthdata20: "ЛПНП холестерин",
    healthdata21: "ЛПВП холестерин",
    healthdata22: "Уровень сахара в крови",
    healthdata23: "До еды",
    healthdata24: "После еды",
    healthdata25: "Vo2Max",
    healthdata26: "Дыхание",
    healthdata27: "Количество шагов",
    healthdata28: "Шаг",
    healthdata29: "Калории",
    healthdata30: "Kcal",
    healthdata31: "Расстояние",
    healthdata32: "KM",
    healthdata33: "темп",
    healthdata35: "S/KM",
    healthdata36: "Min",
    healthdata37: "загрузка здоровых данных",
    healthdata38: "данные о тренировках",
    healthdata39: "предупреждение",
    healthdata40: "несанкционированный",
    healthdata41: "изменить информацию о члене",
    healthdata42: "удалить члена",
    healthdata43: "Email:",
    healthdata44: "телефон:",
    healthdata45: "Хотите удалить этого члена?",
    healthdata46: "Невозможно отображать будущие даты",
    healthdata47: "сегодня",
    //邀请成员,
    addmember1: "Пригласить участника",
    addmember2: "Добавить учетную запись участника",
    addmember4:
      "Через 'Учетную запись участника' вы можете просматривать данные о здоровье участников и устанавливать диапазоны данных оповещений для лучшего контроля здоровья участников",
    addmember5: "Узнать больше",
    addmember6: "Члены группы здоровья",
    addmember7: "Пригласить",
    addmember8: "Присоединиться",
    addmember9: "Пригласить через QR-код",
    addmember10: "Пригласить через WeChat",
    addmember11: "Пригласить присоединиться к группе через QR-код",
    addmember12: "Пригласить присоединиться к группе через WeChat",
    addmember13: "Пригласить через номер телефона/электронную почту",
    addmember14:
      "Пригласить присоединиться к группе через номер телефона/электронную почту",
    addmember15: "Пригласите участников, чтобы понять их состояние здоровья",
    addmember16: "Отправить приглашение",
    addmember17: "Отправлено",
    addmember18: "Ожидание подтверждения",
    addmember19: "Я присоединился",
    addmember20: "Поделиться сейчас",
    addmember21: "Сохранить изображение",
    addmember22: "Я отказался",
    addmember23: "Я вышел",
    addmember24: "Другая сторона вышла",
    addmember25: "Другая сторона отказалась",
    addmember26: "Другая сторона присоединилась",
    addmember27: "Другие способы добавления",

    // 群组二维码,
    code1: "QR-код группы",
    code2: "Группа управления здоровьем",
    code3:
      "QR-код действителен в течение 5 минут, пожалуйста, используйте его вовремя",

    //群组邀请,
    invide1: "Приглашение в группу",
    invide2: "Здоровье членов",
    invide3: "Приглашаем вас присоединиться к группе...",
    invide4: "Присоединиться к этой группе",
    invide5:
      "Для вашей безопасности рекомендуем проверить информацию о группе перед присоединением",
    invide6:
      "После присоединения к группе вы дадите разрешение на просмотр ваших данных здоровья",

    //分享健康数渶设置,
    sethealthdata1: "Настройки здоровья",
    sethealthdata2: "Подтвердить",
    sethealthdata3: "Пожалуйста, установите псевдоним",
    sethealthdata4: "Разрешить все",
    sethealthdata5: "Установить псевдоним",
    sethealthdata6: "Сохранить",
    sethealthdata7: "Пожалуйста, введите",
    sethealthdata8: "Пожалуйста, загрузите формат изображения",
    sethealthdata9: "Пожалуйста, установите псевдоним и аватар",
    sethealthdata10: "Пожалуйста, установите аватар",
    sethealthdata11: "Длина псевдонима составляет 1-8 символов",

    // 设置数据区间,
    setscope1: "Диапазон верхней и нижней границ сердечного ритма",
    setscope2: "Диапазон верхней и нижней границ температуры",
    setscope3: "Диапазон верхней и нижней границ сна",
    setscope4: "Диапазон верхней и нижней границ сердечного ритма плода",
    setscope5: "Уровень сахара в крови до еды",
    setscope6: "Уровень сахара в крови после еды",
    setscope7: "Диапазон верхней и нижней границ насыщения крови кислородом",
    setscope8: "Мочевая кислота у мужчин",
    setscope9: "Мочевая кислота у женщин",
    setscope10: "Систолическое давление",
    setscope11: "Диастолическое давление",
    setscope12: "Верхний предел",
    setscope13: "Нижний предел",
    setscope14: "Настройки предупреждений",
    setscope15: "Настройки сохранены",
    setscope16: "Верхний предел",
    setscope17: "Нижний предел",
    setscope18: "Предупреждение",

    //下载页,
    onload1: "Нажмите",
    onload2: "Присоединиться к группе здоровья",
    onload3: "Открыть в браузере",
    onload4: "Понятно",
    onload5: "Юхонг здоровье, наслаждайтесь здоровьем каждый день",
    onload6: "Бесплатное скачивание из App Store",
    onload7: "Бесплатное скачивание",
    onload8: "Ссылка устарела",
    onload9: "QR-код устарел",
    onload10: "Успешно присоединились",

    // （消息中心）待处理,
    pending1: "Согласиться",
    pending2: "Отказаться",
    pending3: "Повторно отправить приглашение",
    pending4: "Данные отсутствуют",
    pending5: "Приглашение отправлено, ожидание согласия пользователя",
    pending6: "Подтвердить",
    pending7: "Выйти",

    guide1:
      "После входа в здоровье участников, необходимо сначала создать соответствующий тип группы.",
    guide2:
      "После создания группы можно зайти в нее, чтобы просмотреть обзор здоровья пользователя и пригласить новых участников присоединиться к группе.",
    guide3:
      "Приглашение новых участников в группу можно осуществить через сканирование QR-кода, WeChat, номер телефона / электронную почту и другие способы. После вступления новых участников в группу вы можете просматривать их ежедневную динамику здоровья.",
    guide4:
      "Нажмите для просмотра обзора здоровья. Вы можете просматривать данные о здоровье участников и определять, являются ли они нормальными или нет.",
    guide5: "Следующий шаг",
    guide6: "Завершено",
    guide7: "Превышение предупредительного значения",

    invite1: "Пригласить по номеру телефона / электронной почте",
    invite2: "Пожалуйста, введите учетную запись",
    invite3: "Пожалуйста, введите номер телефона",
    invite4: "Пожалуйста, введите электронную почту",
    invite5: "Введите правильный номер телефона",
    invite6: "Введите правильный email",
    invite7: "Присоединились к группе",
    invite8: "Пользователь не существует",
    invite9: "Пожалуйста, выберите страну или регион",
    invite10: "Пожалуйста, введите ключевое слово для поиска",
    invite11: "Подтвердить пользователя",
    invite12: "Пригласить их",
    invite13: "Пожалуйста, выберите"
  }
};



// WEBPACK FOOTER //
// ./src/lang/ru.js